import { useEffect } from 'react';
import { usePlants, useSelectedPlant } from '../../../hooks';
import { useNavigate } from 'react-router-dom';
import { Button, Icon } from '@pella/sash-framework';

import * as classes from './Back.module.css';

/**
 * Back button component with plant description
 */
export const Back = () => {
  const navigate = useNavigate();
  const { selectedPlant } = useSelectedPlant();
  const { data: plants } = usePlants(true);

  const plant = plants?.find((p) => p.id === selectedPlant);

  const handleBack = () => navigate('/');

  // In the event a user navigates directly to a page without a plant selected, redirect to home
  useEffect(() => {
    if (!selectedPlant) navigate('/');
  }, [selectedPlant, navigate]);

  return (
    <div data-testid='back-button-container' className={classes.container}>
      <Button data-testid='back-button' color='secondary' onClick={handleBack}>
        <Icon name='arrow_back' />
        Back
      </Button>
      <p data-testid='plant-description'>{plant?.description}</p>
    </div>
  );
};
